<div>
  <div class="row">
    <div class="col-12 d-flex align-items-center mb-3">
      <span class="far fa-info-circle gray"></span>
      <div class="text-xs font-italic gray ml-2">
        {{ 'automatic-orders.product.explanation' | translate }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <div class="card d-flex container-packing">
        <div class="row">
          <div class="col-sm-6 mbm">
            <form-row-toggle
              [label]="'automatic-orders.product.orderAutomatically'"
              class="mr-3"
              [model]="orderAutomatically"
              (modelChange)="orderAutoChanged($event)"
            ></form-row-toggle>
          </div>
          <div class="col-sm-6">
            <a
              class="link text-right float-right text-sm gray"
              [routerLink]="['/automatic-orders']"
              [title]="'automatic-orders.product.settings' | translate"
              data-cy="'automatic-orders.product.settings'"
            >
              {{ 'automatic-orders.product.settings' | translate }}
            </a>
          </div>
          <div class="col-12">
            <app-modal-product-hs-supplier-confirm
              #modalProductHsSupplierComponent
              (onConnect)="connectProductWithHsSupplier($event)"
            ></app-modal-product-hs-supplier-confirm>
            <div *ngIf="isFetchingConnectedTemplate" class="connected-template-box">
              <div class="connected-template-box-label">
                {{ 'automatic-orders.product.connected-product-header' | translate }}:
              </div>
              <div class="d-flex align-items-center justify-content-center mt-2 mb-2">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">{{ 'loading-spinner.loading' | translate }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="connectedTemplate" class="connected-template-box">
              <div class="connected-template-box-label">
                {{ 'automatic-orders.product.connected-product-header' | translate }}:
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="images-item mr-2 cursor-pointer"
                  (click)="modalProductHsSyncComponent.showChildModal()"
                  (keydown)="modalProductHsSyncComponent.showChildModal()"
                  tabindex="-1"
                >
                  <img
                    class="images-item-image"
                    [src]="connectedTemplate.images[0]?.url"
                    [alt]="connectedTemplate.name"
                  />
                </div>
                <div>
                  <span
                    class="link-bold cursor-pointer"
                    (click)="modalProductHsSyncComponent.showChildModal()"
                    (keydown)="modalProductHsSyncComponent.showChildModal()"
                    tabindex="-1"
                  >
                    {{ connectedTemplate?.name }}
                  </span>
                </div>
              </div>
              <div *ngIf="!isSellable" class="non-sellable-box-container">
                <span class="non-sellable-box">
                  <span
                    class="far fa-exclamation-triangle text-red"
                    style="font-size: 18px; padding-right: 0.5rem"
                  ></span>
                  <span>{{ 'automatic-orders.product.nonSellable' | translate }}</span>
                </span>
              </div>
              <btn
                *ngIf="!isSellable"
                [label]="'automatic-orders.product.nonSellable.btn'"
                [classes]="['btn', 'btn-first', 'p-2-5', 'pl-3', 'pr-3']"
                (onEvent)="modalProductHsSyncComponent.showChildModal()"
              ></btn>
            </div>
            <app-modal-product-hs-sync
              #modalProductHsSyncComponent
              [product]="productDetailService.product"
              (onSelected)="connectProductWithHsTemplate($event)"
              (onInitialFetching)="isFetchingConnectedTemplate = $event"
            ></app-modal-product-hs-sync>
          </div>
          <div class="col-12">
            <form-row-input
              class="width-200"
              [label]="'automatic-orders.product.maxPrice'"
              [inputType]="'number'"
              [model]="maxPrice"
              (modelChange)="maxPriceChanged($event)"
              [appendCustomText]="
                (purchaseCurrencyFromCompany | formatCurrencyWithoutPrice) +
                ' ' +
                ('automatic-orders.product.forPkg' | translate)
              "
            >
            </form-row-input>
            <div class="text-xs font-italic gray">{{ 'automatic-orders.product.explanation2' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6"></div>
  </div>
</div>
